// notificationsApi — thin wrapper around the shared axios `api` instance for the
// in-app notification endpoints. The `api` instance already injects the Bearer
// token and transparently refreshes it on 401 (see pages/chat/api.js), so these
// helpers stay simple.
import api from "../pages/chat/api";

const BASE = "/api/v1/notifications/";

// GET /api/v1/notifications/  -> { notifications: [...], count, has_more?, next_cursor? }
// With `limit` (and optional `before` cursor) the backend returns one page at a
// time (newest first). Omit `limit` for the legacy full-list response.
export const fetchNotifications = async (limit, before) => {
  const params = {};
  if (limit != null) params.limit = limit;
  if (before != null) params.before = before;
  const res = await api.get(BASE, { params });
  return res.data;
};

// GET /api/v1/notifications/unread-count/ -> { unread_count }
export const fetchUnreadCount = async () => {
  const res = await api.get(`${BASE}unread-count/`);
  return res.data?.unread_count ?? 0;
};

// GET /api/v1/notifications/projects/<folderId>/activity/
//   -> { activities: [...], count, has_more, next_cursor }
// The Project Activity Log feed. `category` filters (files/proposal/questionnaire),
// `before` is the id cursor for the next (older) page.
export const fetchProjectActivity = async (folderId, { category, limit, before } = {}) => {
  const params = {};
  if (category && category !== "all") params.category = category;
  if (limit != null) params.limit = limit;
  if (before != null) params.before = before;
  const res = await api.get(`${BASE}projects/${folderId}/activity/`, { params });
  return res.data;
};

// POST /api/v1/notifications/<id>/read/
export const markNotificationRead = async (id) => {
  const res = await api.post(`${BASE}${id}/read/`);
  return res.data;
};

// POST /api/v1/notifications/read-all/
export const markAllNotificationsRead = async () => {
  const res = await api.post(`${BASE}read-all/`);
  return res.data;
};

// DELETE /api/v1/notifications/<id>/  (soft delete)
export const deleteNotification = async (id) => {
  const res = await api.delete(`${BASE}${id}/`);
  return res.data;
};
